// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bAXiq","newExpiryDate":"styles_newExpiryDate__2lGI6","footer":"styles_footer__hCjiI"};